document.addEventListener(
  'submit',
  async function (event) {
    const form = event.target;

    if (!form || !form.matches('form[action*="/cart/add"]')) {
      return;
    }

    const formId = form.getAttribute('id');

    if (!formId) {
      return;
    }

    const giftAddon = document.querySelector(
      '[data-ml-gift-addon][data-product-form-id="' + formId + '"]'
    );

    if (!giftAddon) {
      return;
    }

    const giftCheckbox = giftAddon.querySelector(
      '.ml-gift-box__input'
    );

    if (!giftCheckbox || !giftCheckbox.checked) {
      return;
    }

    const giftVariantId =
      giftCheckbox.getAttribute('data-gift-variant-id');

    if (!giftVariantId) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const formData = new FormData(form);

    const mainVariantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || '1', 10);

    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (match && value !== '') {
        properties[match[1]] = value;
      }
    }

    const mainItem = {
      id: Number(mainVariantId),
      quantity: quantity,
      properties: properties
    };

    const giftItem = {
      id: Number(giftVariantId),
      quantity: 1
    };

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
  items: [
    giftItem,
    mainItem
  ]
})
        }
      );

      if (!response.ok) {
        throw new Error('Unable to add products to cart.');
      }

      window.location.href =
        window.Shopify.routes.root + 'cart';

    } catch (error) {
      console.error('M&L Gift Box error:', error);

      alert(
        'There was a problem adding the gift box. Please try again.'
      );
    }
  },
  true
);